import { scrollTo } from '../utils/scroll-to'

if (window.location.hash) {
  document.addEventListener('DOMContentLoaded', () => {
    const target = document.querySelector(window.location.hash)
    if (target) {
      setTimeout(() => {
        scrollTo(target, true)
      })
    }
  })
}

document.addEventListener('click', (event) => {
  const target = event.target.closest('a[href]')
  if (target) {
    const url = new URL(target.href)
    if (url.hash) {
      const target = document.querySelector(url.hash)
      if (target) {
        event.preventDefault()
        scrollTo(target, true)
      }
    }
  }
})
